import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { aiAgentQueries } from './_internal/aiagent';
import { equipmentQueries } from './_internal/equipment';
import { telecomQueries } from './_internal/telecom';
import { devicesQueries } from './_internal/device';
import { plansQueries } from './_internal/plan';
import { modemsQueries } from './_internal/modems';
import { shipmentQueries } from './_internal/shipment';
import { userQueries } from './_internal/user';
import { companyQueries } from './_internal/company';
import { manualsQueries } from './_internal/manuals';
import { prodoqQueries } from './_internal/prodoq';

export const queries = mergeQueryKeys(
  aiAgentQueries,
  plansQueries,
  modemsQueries,
  devicesQueries,
  equipmentQueries,
  telecomQueries,
  shipmentQueries,
  userQueries,
  companyQueries,
  manualsQueries,
  prodoqQueries,
);
